import React from 'react'
import { Grid, Box, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { img } from '../../imgs'

export const ErrorFallback: React.FC = (): JSX.Element => {
  const classes = useStyles()

  return (
    <Grid container justifyContent="center" alignItems="center" className={classes.page}>
      <Grid item>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item>
            <img src={img.logoStart} alt="..." className={classes.logo} />
          </Grid>
        </Grid>
        <Box width="100%" textAlign="center" my={3} className={classes.title}>
          Что-то пошло не так...
        </Box>
        <Box width="100%" textAlign="center" className={classes.text}>
          На сайте проводятся технические работы. <br />В ближайшее время мы восстановим работу сайта.
        </Box>
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles(({ breakpoints: { down }, palette }: Theme) => ({
  page: {
    height: '100vh',
    color: palette.text.primary,
    padding: '0 15px',
  },
  logo: {
    width: 250,
    height: 'auto',
    position: 'relative',
    [down('sm')]: {
      width: 200,
    },
  },
  title: {
    fontSize: 32,
    fontWeight: 700,
    [down('sm')]: {
      fontSize: 30,
    },
    [down('sm')]: {
      fontSize: 20,
    },
  },
  text: {
    fontSize: 20,
    fontWeight: 300,
    lineHeight: 1.4,
    [down('sm')]: {
      fontSize: 16,
    },
  },
}))
